import {
    FETCH_USER_ROLES_REQUEST,
    FETCH_USER_ROLES_SUCCESS,
    FETCH_USER_ROLES_FAILURE,
} from "../actions/actionTypes";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const userRolesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_ROLES_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_USER_ROLES_SUCCESS:
      return { ...state, loading: false, data: action.payload };

    case FETCH_USER_ROLES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default userRolesReducer;
